'use client';

import type { ReactNode } from 'react';
import { Portal } from '@ark-ui/react';
import { Box } from '@terra/ui-styled-system';
import { HoverCard } from '../../components/hover-card';

export type AssetCellHoverCardProps = {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  trigger: ReactNode;
  children: ReactNode;
  width: string;
  placement: 'bottom-start' | 'bottom-end';
};

export function AssetCellHoverCard({
  isOpen,
  onOpenChange,
  trigger,
  children,
  width,
  placement,
}: AssetCellHoverCardProps) {
  return (
    <HoverCard.Root
      open={isOpen}
      positioning={{ placement, strategy: 'fixed', gutter: 8 }}
      openDelay={200}
      closeDelay={200}
      onOpenChange={({ open }) => onOpenChange(open)}
    >
      <HoverCard.Trigger asChild>
        <Box
          as="span"
          display="inline-flex"
          onClick={(event) => {
            event.stopPropagation();
          }}
        >
          {trigger}
        </Box>
      </HoverCard.Trigger>
      <Portal>
        <HoverCard.Positioner>
          <HoverCard.Content
            borderRadius="lg"
            boxShadow="md"
            bg="bg.default"
            p={4}
            zIndex="popover"
            maxWidth={width}
            w={width}
          >
            {children}
            <HoverCard.Arrow>
              <HoverCard.ArrowTip />
            </HoverCard.Arrow>
          </HoverCard.Content>
        </HoverCard.Positioner>
      </Portal>
    </HoverCard.Root>
  );
}
